import { useMediaQuery, useTheme } from '@mui/material';
import {
  MOBILE_MAX_WIDTH,
  TABLET_MIN_WIDTH,
  TABLET_MAX_WIDTH,
  DESKTOP_MIN_WIDTH,
} from 'src/constants/AppConstants';

export function useIsMobileDevice() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(MOBILE_MAX_WIDTH));
}

export function useIsTabletDevice() {
  const theme = useTheme();
  return useMediaQuery(
    theme.breakpoints.between(TABLET_MIN_WIDTH, TABLET_MAX_WIDTH),
  );
}

export function useIsDesktopDevice() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(DESKTOP_MIN_WIDTH));
}
